import {
  ApiBlueprint,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import type { AppDetail, AppSummary } from './types';

export interface NucleusApi {
  listApps(): Promise<{ apps: AppSummary[] }>;
  getAppDetail(appKey: string): Promise<AppDetail>;
}

export const nucleusApiRef = createApiRef<NucleusApi>({
  id: 'plugin.nucleus.api',
});

export const nucleusApiExtension = ApiBlueprint.make({
  name: 'nucleus-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: nucleusApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) => ({
          async listApps() {
            const baseUrl = await discoveryApi.getBaseUrl('nucleus');
            const res = await fetchApi.fetch(`${baseUrl}/apps`);
            if (!res.ok) throw new Error(`Failed to list apps: ${res.status}`);
            return res.json();
          },
          async getAppDetail(appKey: string) {
            const baseUrl = await discoveryApi.getBaseUrl('nucleus');
            const res = await fetchApi.fetch(`${baseUrl}/apps/${encodeURIComponent(appKey)}`);
            if (!res.ok) throw new Error(`Failed to get app detail for '${appKey}': ${res.status}`);
            return res.json();
          },
        }),
      }),
    ),
});
